// extracted by mini-css-extract-plugin
module.exports = {"MoreInfoBlock":"MoreInfoBlock_MoreInfoBlock__NbCw6","Bordered":"MoreInfoBlock_Bordered__2Qh7f"};